import {
    PLAYLIST_MUTATOR_ADD_CONTENT,
    PLAYLIST_MUTATOR_ADD_SECTION,
    PLAYLIST_MUTATOR_CANCEL_SELECTION,
    PLAYLIST_MUTATOR_COPY,
    PLAYLIST_MUTATOR_HIDE_CONTENT,
    PLAYLIST_MUTATOR_LOAD_SELECTED,
    PLAYLIST_MUTATOR_MOVE_CONTENT_DOWN,
    PLAYLIST_MUTATOR_MOVE_CONTENT_UP,
    PLAYLIST_MUTATOR_REMOVE_CONTENT,
    PLAYLIST_MUTATOR_REMOVE_SECTION,
    PLAYLIST_MUTATOR_RESET_DEFAULTS,
    PLAYLIST_MUTATOR_SELECT_CONTENT,
    PLAYLIST_MUTATOR_SELECT_SECTION,
    PLAYLIST_MUTATOR_SET_BUILDING,
    PLAYLIST_MUTATOR_SET_CC,
    PLAYLIST_MUTATOR_SET_CERTIFICATE_TYPE,
    PLAYLIST_MUTATOR_SET_CLIENT,
    PLAYLIST_MUTATOR_SET_DESCRIPTION,
    PLAYLIST_MUTATOR_SET_HLS,
    PLAYLIST_MUTATOR_SET_ORDER,
    PLAYLIST_MUTATOR_SET_PLAYLIST_TITLE,
    PLAYLIST_MUTATOR_SET_PROPERTY,
    PLAYLIST_MUTATOR_SET_SECTION_TITLE,
    PLAYLIST_MUTATOR_SET_SELECTION_MODE,
    PLAYLIST_MUTATOR_SET_USER_TYPE,
} from '../actionTypes'

const defaultState = {
    activeContent: null,
    activeSection: '0',
    buildingPk: undefined,
    certificateType: 'GUARDIAN',
    clientPk: undefined,
    copied: false,
    description: [
        {
            language: 'ENGLISH',
            text: '',
        },
    ],
    playlistTitle: [
        {
            language: 'ENGLISH',
            text: '',
        },
    ],
    propertyPk: undefined,
    sectionIndex: null,
    sections: [
        {
            title: [
                {
                    language: 'ENGLISH',
                    text: 'Main',
                },
            ],
            content: [],
        },
    ],
    selectionMode: false,
    selectionType: null,
    showValidation: false,
    userType: 'OCCUPANT',
    hls: false,
    cc: false,
    order: 0
}

const playlistMutatorReducer = (state = defaultState, action) => {
    switch (action.type) {
        case PLAYLIST_MUTATOR_COPY:
            return {
                ...defaultState,
                ...action.copied,
            }

        case PLAYLIST_MUTATOR_ADD_CONTENT:
            return {
                ...state,
                sections: state.sections.map((section, index) => {
                    if (action.sectionIndex === index) {
                        return { ...section, content: [...section.content, action.newContent] }
                    } else {
                        return section
                    }
                }),
                selectionMode: false,
                selectionType: null,
            }

        case PLAYLIST_MUTATOR_ADD_SECTION:
            return {
                ...state,
                sections: [
                    ...state.sections,
                    {
                        title: [
                            {
                                language: 'ENGLISH',
                                text: '',
                            },
                        ],
                        content: [],
                    },
                ],
            }

        case PLAYLIST_MUTATOR_CANCEL_SELECTION:
            return {
                ...state,
                selectionMode: false,
                selectionType: null,
            }

        case PLAYLIST_MUTATOR_HIDE_CONTENT:
            return {
                ...state,
                sections: state.sections.map((section, sectionIndex) => {
                    if (action.sectionIndex === sectionIndex) {
                        return {
                            ...section,
                            content: section.content.map((content, contentIndex) => {
                                if (action.contentIndex === contentIndex) {
                                    return { ...content, hidden: !content.hidden }
                                } else {
                                    return content
                                }
                            }),
                        }
                    } else {
                        return section
                    }
                }),
            }

        case PLAYLIST_MUTATOR_LOAD_SELECTED:
            const d1 = action.selectedPlaylist.d1.split('#')
            return {
                ...defaultState,
                buildingPk: d1[4],
                certificateType: action.selectedPlaylist.certificateType,
                clientPk: d1[1],
                clientName: action.selectedPlaylist.meta.clientName,
                propertyName: action.selectedPlaylist.meta.propertyName,
                buildingName: action.selectedPlaylist.meta.buildingName,
                description: action.selectedPlaylist.meta.description || [
                    {
                        language: 'ENGLISH',
                        text: '',
                    },
                ],
                playlistTitle: action.selectedPlaylist.meta.title || [
                    {
                        language: 'ENGLISH',
                        text: '',
                    },
                ],
                propertyPk: d1[3],
                sections: action.selectedPlaylist.sections,
                userType: action.selectedPlaylist.userType,
                hls: action.selectedPlaylist.hls,
                cc: action.selectedPlaylist.cc,
                order: action.selectedPlaylist.order != null ? Number(action.selectedPlaylist.order) : 0,
                createdAt: action.selectedPlaylist.meta.createdAt
            }

        case PLAYLIST_MUTATOR_MOVE_CONTENT_DOWN:
            return {
                ...state,
                sections: state.sections.map((section, sectionIndex) => {
                    if (action.sectionIndex === sectionIndex) {
                        return {
                            ...section,
                            content: section.content
                                .slice(0, action.contentIndex)
                                .concat(section.content[action.contentIndex + 1])
                                .concat(section.content[action.contentIndex])
                                .concat(section.content.slice(action.contentIndex + 2)),
                        }
                    } else {
                        return section
                    }
                }),
            }

        case PLAYLIST_MUTATOR_MOVE_CONTENT_UP:
            return {
                ...state,
                sections: state.sections.map((section, sectionIndex) => {
                    if (action.sectionIndex === sectionIndex) {
                        return {
                            ...section,
                            content: section.content
                                .slice(0, action.contentIndex - 1)
                                .concat(section.content[action.contentIndex])
                                .concat(section.content[action.contentIndex - 1])
                                .concat(section.content.slice(action.contentIndex + 1)),
                        }
                    } else {
                        return section
                    }
                }),
            }

        case PLAYLIST_MUTATOR_REMOVE_CONTENT:
            return {
                ...state,
                sections: state.sections.map((section, sectionIndex) => {
                    if (action.sectionIndex === sectionIndex) {
                        return {
                            ...section,
                            content: section.content
                                .slice(0, action.contentIndex)
                                .concat(section.content.slice(action.contentIndex + 1)),
                        }
                    } else {
                        return section
                    }
                }),
            }

        case PLAYLIST_MUTATOR_REMOVE_SECTION:
            return {
                ...state,
                sections: state.sections
                    .slice(0, action.sectionIndex)
                    .concat(state.sections.slice(action.sectionIndex + 1)),
            }

        case PLAYLIST_MUTATOR_RESET_DEFAULTS:
            return defaultState

        case PLAYLIST_MUTATOR_SELECT_CONTENT:
            return {
                ...state,
                activeContent: action.content,
            }

        case PLAYLIST_MUTATOR_SELECT_SECTION:
            return {
                ...state,
                activeSection: action.key,
            }

        case PLAYLIST_MUTATOR_SET_BUILDING:
            return {
                ...state,
                buildingPk: action.buildingPk,
                buildingName: action.buildingName
            }

        case PLAYLIST_MUTATOR_SET_CERTIFICATE_TYPE:
            return {
                ...state,
                certificateType: action.certificateType,
            }

        case PLAYLIST_MUTATOR_SET_CLIENT:
            return {
                ...state,
                clientPk: action.clientPk,
                clientName: action.clientName
            }

        case PLAYLIST_MUTATOR_SET_DESCRIPTION:
            return {
                ...state,
                description: state.description.map((description, index) => {
                    if (index === 0) return { language: 'ENGLISH', text: action.description }
                    return description
                }),
            }

        case PLAYLIST_MUTATOR_SET_PLAYLIST_TITLE:
            // TODO: Don't assume someone is working in English
            return {
                ...state,
                playlistTitle: state.playlistTitle.map((translation, index) => {
                    if (index === 0) return { ...translation, text: action.title }
                    return translation
                }),
            }

        case PLAYLIST_MUTATOR_SET_PROPERTY:
            return {
                ...state,
                propertyPk: action.propertyPk,
                propertyName: action.propertyName
            }

        case PLAYLIST_MUTATOR_SET_SECTION_TITLE:
            // TODO: Don't assume someone is working in English
            return {
                ...state,
                sections: state.sections.map((section, index) => {
                    if (action.sectionIndex === index) {
                        return {
                            ...section,
                            title: section.title.map((translation, i) => {
                                if (i === 0) return { ...translation, text: action.newTitle }
                                return translation
                            }),
                        }
                    } else {
                        return section
                    }
                }),
            }

        case PLAYLIST_MUTATOR_SET_SELECTION_MODE:
            return {
                ...state,
                sectionIndex: action.sectionIndex,
                selectionMode: true,
                selectionType: action.selectionType,
            }

        case PLAYLIST_MUTATOR_SET_USER_TYPE:
            return {
                ...state,
                userType: action.userType,
            }

        case PLAYLIST_MUTATOR_SET_CC:
            return {
                ...state,
                cc: action.cc
            }

        case PLAYLIST_MUTATOR_SET_HLS:
            return {
                ...state,
                hls: action.hls
            }

        case PLAYLIST_MUTATOR_SET_ORDER:
            return {
                ...state,
                order: action.order !== undefined && action.order !== '' ? Number(action.order) : 0
            }

        default:
            return state
    }
}

export default playlistMutatorReducer
